<template>
    <div class="bordas acoes-content">
        <button type="button" class="btn btn-sm btn-acoes" :class="listagemFiltradaStatus == 5 ? 'btn-primary' : 'btn-outline-secondary'" @click="impedimento()">
            <i class="fa fa-ban" aria-hidden="true"></i>
            Impedir Leito
        </button>

        <button type="button" class="btn btn-sm btn-acoes" :class="listagemFiltradaStatus == 6 ? 'btn-primary' : 'btn-outline-secondary'"  @click="liberar()">
            <i class="fa fa-check" aria-hidden="true"></i>
            Liberar Leito
        </button>

        <button type="button" class="btn btn-sm btn-acoes" :class="listagemFiltradaStatus == 7 || listagemFiltradaStatus == 8 ? 'btn-primary' : 'btn-outline-secondary'"  @click="filtraTransferenciaEtapaUm()">
            <i class="fa fa-exchange" aria-hidden="true"></i>
            Transferir Leito
        </button>

        <button type="button" class="btn btn-sm btn-acoes" :class="listagemFiltradaStatus == 9 ? 'btn-primary' : 'btn-outline-secondary'" @click="ceder()">
            <i class="fa fa-share" aria-hidden="true"></i>
            Ceder Leito
        </button>

        <button type="button" class="btn btn-sm btn-acoes" :class="listagemFiltradaStatus == 14 ? 'btn-primary' : 'btn-outline-secondary'" @click="reservar()">
            <i class="fa fa-flag" aria-hidden="true"></i>
            Reservar Leito
        </button>

        <!-- <button type="button" class="btn btn-sm btn-acoes" :class="listagemFiltradaStatus == 10 ? 'btn-primary' : 'btn-outline-secondary'" @click="confirmaAih()">
            <i class="fa fa-money" aria-hidden="true"></i>
            Gerar AIH
        </button> -->


        <b-modal
            id="modalConfirmaAih"
            ref="modalConfirmaAih"
            title="Atenção!"
            ok-title="Sim"
            cancel-title="Não"
            centered
            @cancel="fechaModalAih()"
            @ok="gerarAih()"
        >

            <p class="text-center">Todas ações neste sistema são gravadas pela secretaria de saúde para fins de auditoria através do CPF e IP do usuário.</p>
            <p class="text-center">Todas as AIHs geradas pelo SISAIH01 serão comparadas com o período de internacao do paciente no censo. 
                Todas as AIHs com divergencias serão glosadas e sujeitas a auditoria.
            </p>
            <p class="text-center">De acordo com o Art. 313–A do Código Penal brasileiro, constitui crime contra a Administração Pública, 
                a inserção de dados falsos, alteração ou exclusão de dados corretos com o fim de obter vantagem indevida ou causar dano,
                sob pena de reclusão de dois a doze anos, e multa.
            </p>

            <p class="text-center text-danger">Você gostaria de continuar?</p>
        </b-modal>
        

    </div>
</template>

<script>
export default {
    computed: {
        listagemFiltradaStatus () {
            // Filtros inseridos pelas ações da barra lateral PARA LISTAR SOMENTE DO TIPO ESPECIFICADO
            // SIDEBARLEFT => 0=Livres, 1=Ocupados, 2=Impedidos, 3=Cedidos,
            // 11=ocupados-longap(no clique: Notifica LongaP), 12=ocupados+longap(no clique: Editar LongaP) 13=Reservados

            // SIDEBARRIGHT => 5=livres(no clique: Impedir Leito), 6=impedidos (no clique: Liberar Leitos -SidebarRight),
            // 7=ocupados(no clique: Transferir Leito - Etapa 1), 8=livres (no clique:  Transferir Leito - Etapa 2)
            // 9=livres(no clique: Ceder Leito), 10=ocupados(no clique: Gerar AIH), 14=Livres(no clique: Reservar Leito)
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        }
    },
     methods: {
        impedimento () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 5 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 5)
        },
        liberar () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 6 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 6)
        },
        filtraTransferenciaEtapaUm () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 7 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 7)
        },
        ceder () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 9 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 9)
        },
        reservar () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 14 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 14)
        },
        confirmaAih () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 10 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$refs.modalConfirmaAih.show()
        },
        fechaModalAih () {
            this.$refs.modalConfirmaAih.hide()
        },
        gerarAih () {
            this.$refs.modalConfirmaAih.hide()

            this.$store.commit('leitos/setListagemFiltradaStatus', 10)
        }
     }
}
</script>

<style>
    .acoes-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }

    .btn-acoes {
        margin: 6px;
        min-width: 125px;
    }

    @media (min-width: 1154px) {

        .acoes-content {
            flex-direction: column;
        }

        .btn-acoes {
            margin: 0 0 10px 0;
        }
    }
</style>

